import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'koreancar',
    title: 'KoreanCar API',
    description: 'The Ultimate Korean Car Data API for Dealerships & Marketplaces',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'OpenAPI',
            'TypeScript',
            'Django',
            'Docker',
        ],
        url: 'https://carsapi.unrealos.com',
    },
};

export default data;
